<template>
	<ul class="flex bm-row bm-row-cols-3 bm-gy-4 bm-gx-1 bm-size-3_5 leading-6">
		<li
			v-for="item in list"
			:key="item.value"
			:style="{ flex: 'initial', width: 'auto' }"
			:class="{
				'bm-col': true,
				'box-border': true,
				'cursor-pointer': true,
				'hover:bm-text-effect': true,
				'actived:bm-text-effect': item.value === oldLocaleObjReverse,
			}"
			@click="
				() => {
					$$switchLanguage(item.value);
				}
			"
		>
			{{ item.title || item.name }}
		</li>
	</ul>
</template>

<script>
import { OLD_LOCALES_OBJ_REVERSE } from '~/common/js/const';
import { usePatchStore } from '~/common/js/patch';
import commonMixins from '../mixins';
export default {
	mixins: [commonMixins],
	props: {
		list: {
			type: [],
			default: () => [],
		},
	},
	setup() {
		const { store } = usePatchStore();
		const oldLocaleObjReverse = computed(() => {
			const locale = store.locale;
			return (OLD_LOCALES_OBJ_REVERSE || {})[locale] || locale;
		});
		return {
			store,
			oldLocaleObjReverse,
		};
	},
};
</script>
